import { useCallback, useMemo, useState } from "react";

import { ReceiptModel } from "@doitintl/cmp-models";
import {
  type DocumentSnapshotModel,
  getCollection,
  type ModelWithDataAndRef,
  type WithModel,
} from "@doitintl/models-any";

import { usePaginatedQuery } from "../../Components/hooks/usePaginatedQuery";
import CashGraph from "./CashGraph";
import TableServerPaging from "./TableServerPaging";
import { useCashGraphData } from "./useCashGraphData";

export const CollectionCash = () => {
  const cashGraphData = useCashGraphData();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBy, setOrderBy] = useState<Array<string & keyof ReceiptModel>>(["PAYDATE"]);
  const [orderDirection, setOrderDirection] = useState<"asc" | "desc">("asc");

  const transform = useCallback(
    (data: WithModel<ReceiptModel>, snap: DocumentSnapshotModel<ReceiptModel>): ModelWithDataAndRef<ReceiptModel> => ({
      data,
      ref: snap.ref,
    }),
    []
  );

  const setOrderByFieldAndDirection = useCallback(
    (fields: Array<string & keyof ReceiptModel>, direction: "asc" | "desc") => {
      setOrderBy(fields);
      setOrderDirection(direction);
    },
    []
  );

  const query = useMemo(() => getCollection(ReceiptModel).where("CANCELED", "==", false), []);
  const { items, handlePrevPage, handleNextPage } = usePaginatedQuery({
    query,
    options: { orderBy, transform, rowsPerPage, orderDirection },
  });

  return (
    <>
      {cashGraphData && <CashGraph data={cashGraphData} />}
      <TableServerPaging
        changePage={(page: number) => {
          if (page > currentPage) {
            handleNextPage!();
          } else if (page < currentPage) {
            handlePrevPage!();
          }

          setCurrentPage(page);
        }}
        changeRowsPerPage={setRowsPerPage}
        rows={items}
        title="Customer Receipts"
        onSortBy={(field, direction) => {
          setOrderByFieldAndDirection([field], direction);
        }}
        rowsPerPage={rowsPerPage}
      />
    </>
  );
};
